/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { versionGet } from '../fn/version/version-get';
import { VersionGet$Params } from '../fn/version/version-get';
import { versionInfoGet } from '../fn/version/version-info-get';
import { VersionInfoGet$Params } from '../fn/version/version-info-get';
import { versionRevisionGet } from '../fn/version/version-revision-get';
import { VersionRevisionGet$Params } from '../fn/version/version-revision-get';
import { versionTagGet } from '../fn/version/version-tag-get';
import { VersionTagGet$Params } from '../fn/version/version-tag-get';

@Injectable({ providedIn: 'root' })
export class ApiFromVersionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `versionInfoGet()` */
  static readonly VersionInfoGetPath = '/Version/info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `versionInfoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionInfoGet$Response(params?: VersionInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return versionInfoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `versionInfoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionInfoGet(params?: VersionInfoGet$Params, context?: HttpContext): Observable<void> {
    return this.versionInfoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `versionGet()` */
  static readonly VersionGetPath = '/Version';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `versionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionGet$Response(params?: VersionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return versionGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `versionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionGet(params?: VersionGet$Params, context?: HttpContext): Observable<void> {
    return this.versionGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `versionTagGet()` */
  static readonly VersionTagGetPath = '/Version/tag';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `versionTagGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionTagGet$Response(params?: VersionTagGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return versionTagGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `versionTagGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionTagGet(params?: VersionTagGet$Params, context?: HttpContext): Observable<void> {
    return this.versionTagGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `versionRevisionGet()` */
  static readonly VersionRevisionGetPath = '/Version/revision';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `versionRevisionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionRevisionGet$Response(params?: VersionRevisionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return versionRevisionGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `versionRevisionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionRevisionGet(params?: VersionRevisionGet$Params, context?: HttpContext): Observable<void> {
    return this.versionRevisionGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
